import Navbar from '@/components/feature/Navbar';
import Footer from '@/components/feature/Footer';
import JsonLd from '@/components/base/JsonLd';
import HeroSection from './components/HeroSection';
import CategoryGrid from './components/CategoryGrid';
import FeaturedBooks from './components/FeaturedBooks';
import FeaturedArticles from './components/FeaturedArticles';
import Testimonials from './components/Testimonials';
import Newsletter from './components/Newsletter';
import { organizationSchema, websiteSchema, generateWebPageSchema } from '@/mocks/schema';

export default function Home() {
  return (
    <>
      <JsonLd data={organizationSchema as unknown as Record<string, unknown>} />
      <JsonLd data={websiteSchema as unknown as Record<string, unknown>} />
      <JsonLd data={generateWebPageSchema(
        '姨母的诱惑——成人情感小说精品推荐 | 探索人性情感文学',
        '探索「姨母的诱惑」经典情感叙事主题，汇聚高品质成人文学作品推荐、情感故事解析与创作技巧分享。',
        'https://guangzhousoap.cn'
      ) as unknown as Record<string, unknown>} />
      <Navbar />
      <main>
        <HeroSection />
        <CategoryGrid />
        <FeaturedBooks />
        <FeaturedArticles />
        <Testimonials />
        <Newsletter />
      </main>
      <Footer />
    </>
  );
}